import { EventEmitter, Injectable } from '@angular/core';
import { FilterElementSize } from './filter-elements';

export type FilterEmitterType = { key: string, term?: string | undefined };

@Injectable()
export abstract class AbstractFilterElementComponent {
  static uniqueId = 0;

  abstract componentClass: string;

  abstract size: FilterElementSize;

  abstract label: string | undefined;

  abstract filterKey: string;

  abstract filterActive: boolean;

  abstract filterTerm: EventEmitter<FilterEmitterType>;

  abstract ngOnChanges(changes: unknown): void;

  abstract onFilterChange(changes: unknown): void;

  protected value: unknown = null;

  protected inputId = AbstractFilterElementComponent.uniqueId++;
}
